import {BREAK_POINTS} from '../settings';
import {fadeIn, fadeOut} from './fade';

export default function() {
  let elWrapper,elBtns,elTarget;
	let isScrollable = undefined;

  function init() {
    elBody = document.querySelector('body');
    elWrapper = document.querySelector('.js-gnav-wrapper');
    elBtns = document.querySelectorAll('.js-gnav-toggle');
    elTarget = document.querySelector('.js-gnav-target');
    label = document.querySelector('.js-gnav-label');

    [].forEach.call(elBtns, el => {
      el.addEventListener('click', clickHandle)
    });

		elTarget.addEventListener('touchmove', function(e) {
			if(isScrollable == undefined) {
				let unitHeigth = elTarget.offsetHeight;
				let scrollHeight = elTarget.scrollHeight;
				isScrollable = false;

				if(scrollHeight > unitHeigth) {
					isScrollable = true;
				}
			}
			if(!isScrollable) {
				e.preventDefault();
			}
    });

  }

	function hide() {
		elBody.classList.remove('is-gnav-show');
		elWrapper.setAttribute("aria-expanded", false);
		label.innerText = 'menu';
		fadeOut(elBtns, elTarget);

		[].forEach.call(elBtns, el => {
			el.classList.remove('is-active');
		});
	}

	function show() {
		elBody.classList.add('is-gnav-show');
		elWrapper.setAttribute("aria-expanded", true);
		label.innerText = 'close';
		isShow = true;
		fadeIn(elBtns, elTarget);

		[].forEach.call(elBtns, el => {
			el.classList.add('is-active');
		});
	}

  function toggleAtributes() {
    if(elTarget.getAttribute('aria-hidden') == "true") {
			show();
    } else {
			hide();
    }
  }

  function clickHandle(e) {
    e.preventDefault();
    toggleAtributes();
  }

  window.addEventListener('DOMContentLoaded', init);
}
